import Question from '@evidentid/ido-lib/interfaces/Question';

export default function findQuestionsForAttributeTypes(questions: Question[], attributeTypes: string[]): Question[] {
    return questions.filter((question) =>
        attributeTypes.includes(question.attrType) ||
        attributeTypes.includes(question.metadata?.submissionAttributeType),
    );
}
